import { User } from 'core/application/account/loginUser'
import { Permissions } from 'core/application/account/permissions'

type useUserAccessReturn = {
  canAccessDashboard: boolean
  canAccessAdminDashboard: boolean
  canAccessGhra: boolean
  canAccessCsiDashboard: boolean
  canAccessDocReviewDashboard: boolean
  canAccessIchraDecisionTool: boolean
  canAccessEligibleEmployeeSignupWizard: boolean
  canAccessNonEligibleEmployeeSignupWizard: boolean
  canAccessNonEligibleEmployeeDashboard: boolean
}

const userPermissionAccess = (user: User): useUserAccessReturn => {
  const permissions = user?.permissions || []

  const canAccessDashboard =
    permissions.includes(Permissions.AccessAdminDashboard) ||
    permissions.includes(Permissions.AccessEligibleEmployeeDashboard)

  const canAccessAdminDashboard = permissions.includes(Permissions.AccessAdminDashboard)
  const canAccessEligibleEmployeeSignupWizard = permissions.includes(Permissions.AccessEligibleEmployeeSignupWizard)
  const canAccessNonEligibleEmployeeSignupWizard = permissions.includes(
    Permissions.AccessNonEligibleEmployeeSignupWizard,
  )

  const canAccessGhra = permissions.some(
    (p) => p !== Permissions.AccessDocReviewDashboard && p != Permissions.AccessCsiDashboard,
  )

  const canAccessCsiDashboard = permissions.includes(Permissions.AccessCsiDashboard)

  const canAccessDocReviewDashboard = permissions.includes(Permissions.AccessDocReviewDashboard)

  const canAccessIchraDecisionTool = permissions.includes(Permissions.AccessIchraDecisionTools)
  const canAccessNonEligibleEmployeeDashboard = permissions.includes(Permissions.AccessNonEligibleEmployeeDashboard)

  return {
    canAccessDashboard,
    canAccessAdminDashboard,
    canAccessGhra,
    canAccessCsiDashboard,
    canAccessDocReviewDashboard,
    canAccessIchraDecisionTool,
    canAccessEligibleEmployeeSignupWizard,
    canAccessNonEligibleEmployeeSignupWizard,
    canAccessNonEligibleEmployeeDashboard,
  }
}

export default userPermissionAccess
